module.exports = __webpack_public_path__ + "img/fondo.dea4275e.jpg";